<template>
  <div id="privacy">
    <h2>プライバシーポリシー</h2>
    <p>
      ナガイホーム（以下、「当サイト」と言います。）では、お客様からお預かりする個人情報の重要性を強く認識しており、個人情報の保護に関する法律、その他の関係法令を遵守すると共に、以下に定めるプライバシーポリシーに従って、個人情報を安全かつ適切に取り扱うことを宣言します。
    </p>
    <h4>個人情報の定義</h4>
    <p>
      本プライバシーポリシーにおいて、個人情報とは生存する個人に関する情報であり、氏名、生年月日、住所、電話番号、メールアドレス等、特定の個人を識別することができるものをいいます。
    </p>
    <h4>個人情報の管理</h4>
    <p>
      お客様からお預かりした個人情報は、不正アクセス、紛失、漏えい等が起こらないよう、慎重かつ適切に管理します。
    </p>
    <h4>個人情報の利用目的</h4>
    <p>
      当サイトでは、お客様からのお問い合わせや商品・サービスへのお申し込み等を通じて、お客様の氏名、生年月日、住所、電話番号、メールアドレス等の個人情報をご提供いただく場合があります。その場合は、以下に示す利用目的のために、適正に利用するものと致します。
    </p>
    <ul>
      <li>お問い合わせに対する回答</li>
      <li>お申し込みいただいた商品・サービス等の提供</li>
      <li>アンケート、ご意見、ご感想の依頼</li>
      <li>景品、プレゼント等の発送</li>
      <li>当サイト改善を目的に分析などを行うため</li>
      <li>新サービス・新商品の開発を目的とし分析等を行うため</li>
      <li>
        個人情報を含まない形でデータを集計し、当サイト、及びお客様の参考資料を作成するため
      </li>
    </ul>
    <h4>個人情報の第三者提供</h4>
    <p>
      お客様からお預かりした個人情報を、個人情報保護法その他の法令に基づき開示が認められる場合を除き、お客様ご本人の同意を得ずに第三者に提供することはありません。
    </p>
    <h4>個人情報の開示・訂正・削除について</h4>
    <p>
      お客様からお預かりした個人情報の確認、訂正・削除等をご希望の場合、お客様ご本人が当サイトのお問い合わせフォームまたはメールアドレスよりお申し出ください。<br />
      適切な本人確認を行った後、速やかに対応いたします。
    </p>
    <h4>アクセス解析ツールについて</h4>
    <p>
      当サイトは、Googleが提供するアクセス解析ツール「Googleアナリティクス」を利用しています。<br />
      Googleアナリティクスは、Cookieを使用することでお客様のトラフィックデータを収集しています。
      お客様はブラウザの設定でCookieを無効にすることで、トラフィックデータの収集を拒否することができます。<br />
      なお、トラフィックデータからお客様個人を特定することはできません。詳しくは<a
        target="_blank"
        rel="noopener noreferrer"
        href="https://marketingplatform.google.com/about/analytics/terms/jp/"
        >Googleアナリティクス利用規約</a
      >をご確認ください。
    </p>
    <h4>Cookie（クッキー）について</h4>
    <p>
      Cookie（クッキー）とは、お客様のサイト閲覧履歴を、お客様のコンピュータにデータとして保存しておく仕組みです。<br />
      なお、Cookieに含まれる情報は当サイトや他サイトへのアクセスに関する情報のみであり、氏名、住所、メール
      アドレス、電話番号などの個人情報は含まれません。<br />
      従って、Cookieに保存されている情報からお客様個人を特定することはできません。
    </p>
    <h4>免責事項</h4>
    <p>
      当サイトに掲載されている情報・資料の内容については、万全の注意を払って掲載しておりますが、掲載された情報の正確性を何ら保証するものではありません。従いまして、当サイトに掲載された情報・資料を利用、使用、ダウンロードする等の行為に起因して生じる結果に対し、一切の責任を負いません。<br />
      なお、当サイトに掲載された情報の正確性を鑑みた際に、予告なしで情報の変更・削除を行う場合がございますので、予めご了承ください。
    </p>
    <h4>本ポリシーの変更について</h4>
    <p>
      当サイトは、法令の制定、改正等により、本ポリシーを適宜見直し、予告なく変更する場合があります。<br />
      本ポリシーの変更は、変更後の本ポリシーが当サイトに掲載された時点、またはその他の方法により変更後の本ポリシーが閲覧可能となった時点で有効になります。
    </p>
    <p>以上</p>
    <p>制定日:2022年7月4日</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#privacy {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 $h-gap;
  box-sizing: content-box;
  counter-reset: h4;
  h2 {
    font-weight: bold;
    color: $color_blue;
    font-size: 2rem;
    padding-top: calc($v-gap/2);
    margin-bottom: 1em;
    position: relative;
    padding-bottom: 0.5em;
    &::after {
      content: "";
      display: block;
      height: 4px;
      width: 3em;
      bottom: 0;
      position: absolute;
      background-color: $color_blue;
    }
  }
  h4 {
    font-size: clamp(1.2rem, 1.5vw, 1.5rem);
    font-weight: bold;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid $fontcolor;
    &::before {
      counter-increment: h4;
      content: counter(h4) ".";
      margin-right: 0.5em;
    }
  }
  p {
    font-size: 1rem;
    line-height: 2;
    margin-bottom: 4rem;
    br {
      margin-bottom: 1em;
    }
    a {
      color: $color_blue;
      text-decoration: underline;
    }
  }
  ul {
    line-height: 2;
    margin-bottom: 4rem;
    li {
      font-size: 0.8rem;
      list-style-type: disc;
      list-style-position: inside;
    }
  }
}
</style>
